import { notification, TablePaginationConfig } from "antd";
import {
  FilterValue,
  SorterResult,
  TableCurrentDataSource,
} from "antd/es/table/interface";
import { ChangeEventHandler, useCallback, useState } from "react";
import { GenericTableProps } from "../../components/tables/GenericTable";
import config from "../../config";
import _ from "lodash";

export default function useTablePagination<Model>(
  fetchData: GenericTableProps<Model>["fetchData"],
) {
  const [pagination, setPagination] = useState<TablePaginationConfig>();
  const [queryParams, setQueryParams] = useState(new URLSearchParams());
  const [search, setSearch] = useState("");

  const [isSearching, setIsSearching] = useState(false);

  const onPaginationChange = useCallback(
    (
      _pagination: TablePaginationConfig,
      filters: Record<string, FilterValue | null>,
      _sorter: SorterResult<Model> | SorterResult<Model>[],
      extra: TableCurrentDataSource<Model>,
    ) => {
      // Typscript "mini-hack" as we don't handle multiple sorters
      const sorter = _sorter as SorterResult<Model>;

      // Debug
      console.log("");
      console.log("pagination", pagination);
      console.log("filters", filters);
      console.log("sorter", sorter);
      console.log("extra.action", extra.action);
      console.log("extra.currentDataSource", extra.currentDataSource);
      console.log("");

      // Update pagination state
      setPagination(_pagination);

      // Retreive pagination data
      const current = _pagination.current || 0;
      const limit = _pagination.pageSize || 0;
      const offset = (current - 1) * limit;
      // const search = filters.search || "";

      // Build query params
      const _queryParams = new URLSearchParams();
      _queryParams.set("limit", limit.toString());
      _queryParams.set("offset", offset.toString());
      _queryParams.set("search", search);
      _queryParams.set("random_key_for_avoid_cache", Math.random().toString());

      if (sorter?.column?.dataIndex) {
        console.log("sortField", sorter.column.dataIndex, sorter.order);
        _queryParams.set("sortField", sorter.column.dataIndex?.toString());
        _queryParams.set("sortOrder", sorter.order || "descend");
      }

      // Fetch data
      setQueryParams(_queryParams);
      const queryParamsString = _queryParams.toString();
      fetchData(queryParamsString);
    },
    [fetchData, pagination, search],
  );
  const fetchOnSearchChanged = useCallback(
    async (value: string) => {
      try {
        console.log("search", value);

        setSearch(value);
        setIsSearching(true);

        queryParams.set("search", value);
        console.log("newQueryParams");
        console.log(queryParams);

        // if (!pagination) {
        //   const { tablePageSize } = config;
        //   url = `?limit=${tablePageSize}&offset=${0}&sortOrder=${sortOrder}&search=${value}&random_key_for_avoid_cache=${Math.random()}`;
        // } else {
        //   const current = pagination.current || 0;
        //   const limit = pagination.pageSize || 0;
        //   const offset = (current - 1) * limit;
        //   url = `?limit=${limit}&offset=${offset}&sortOrder=${sortOrder}&search=${value}&random_key_for_avoid_cache=${Math.random()}`;
        // }

        // console.log("url", url);

        await fetchData(queryParams?.toString());
      } catch (error) {
        console.error("Error fetchOnSearchChanged", error);
        notification.error({
          message: "Erreur",
          description: "Une erreur est survenue lors de la recherche.",
        });
      } finally {
        setIsSearching(false);
      }
    },
    [fetchData, queryParams],
  );

  /**
   * Debounce the search to avoid making too many requests when typing
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    _.debounce(fetchOnSearchChanged, config.tableSearchDebounceTime),
    [fetchOnSearchChanged],
  );

  /**
   * Handle the search input change and call the debounced search
   */
  const onSearchChanged: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      debouncedSearch(event.target.value);
    },
    [debouncedSearch],
  );
  return {
    onPaginationChange,
    onSearchChanged,
    isSearching,
    search,
  };
}
